<template>
    <div
        id="login-box"
        class="login-box">
        <div class="login-title">
            金盒子自动化测试系统
        </div>
        <input
            v-model="username"
            class="login-input"
            type="text"
            name="firstname"
            placeholder="请输入手机号">
        <input
            v-model="verifyCode "
            class="login-input"
            name="firstname"
            placeholder="请输入短信验证码">
        <a-button
            v-on:click="fetchVerificationCode"
            class="verification-button"
            size="large">
            点击获取验证码
        </a-button>
        <a-icon
            v-on:click="login"
            class="login-button"
            type="right-circle" />
    </div>
</template>

<script>
 import Vue from "vue"

 import message from 'ant-design-vue/lib/message';
 import Button from "ant-design-vue/lib/button";

 import {isEmptyOrWhitespace, isPhoneNumber} from "../util/utils.js"

 Vue.component(Button.name, Button);

 export default {
     name: 'LoginDialog',
     data() {
         return {
             username: '',
             verifyCode: ''
         };
     },
     methods: {
         login() {
             if (isEmptyOrWhitespace(this.username) && !isPhoneNumber(this.username)) {
                 message.error("请输入手机号并保证格式正确")
             } else if (isEmptyOrWhitespace(this.verifyCode )) {
                 message.error("请输入短信验证码")
             } else {
                 const url = process.env.VUE_APP_API_SERVER + '/user/verify-vcode'

                 var data = {
                     Username: this.username,
                     VerifyCode: this.verifyCode
                 };

                 fetch(url, {
                     method: 'POST',
                     body: JSON.stringify(data),
                     headers: new Headers({
                         'Content-Type': 'application/json',
                     })
                 }).then(res => {
                     if (!res.ok) {
                         throw res;
                     }
                     return res.json();
                 }).catch(error => {
                     message.error("验证验证码失败: " + error)
                 }).then(response => {
                     if (response.Status == 0) {
                         if (response.Token && response.Token != "") {
                             localStorage.setItem('accessToken', response.Token);
                             this.$router.replace('/home');
                         }
                     } else if (response.Status == 2) {
                         message.error("提交表单格式有误")
                     } else if (response.Status == 3) {
                         message.error("该手机号并没有在后台创建")
                     } else if (response.Status == 4) {
                         message.error("错误的验证码")
                     } else if (response.Status == 6) {
                         message.error("服务器内部错误")
                     } else {
                         message.error("未知错误，错误码: " + response.Status)
                     }
                 });
             }
         },
         fetchVerificationCode() {
             if (isEmptyOrWhitespace(this.username)) {
                 message.error("请输入手机号")
             } else if (!isPhoneNumber(this.username)) {
                 message.error("请输入正确的手机号")
             } else {
                 const url = process.env.VUE_APP_API_SERVER + '/user/create-vcode'

                 var data = {
                     Username: this.username
                 };

                 fetch(url, {
                     method: 'POST',
                     body: JSON.stringify(data),
                     headers: new Headers({
                         'Content-Type': 'application/json',
                     })
                 }).then(res => {
                     if (!res.ok) {
                         throw res;
                     }
                     return res.json();
                 }).catch(error => {
                     message.error("获取验证码失败: " + error)
                 }).then(response => {
                     message.success("验证码已经发送")
                 });
             }
         }
     }
 };
</script>

<style scoped>
 .login-box {
     flex-direction: column;
     align-items: center;
     justify-content: center;
     display: flex;
     width: 100%;
     height: 100%;
     background-color: rgba(255, 255, 255, 0.8);
 }

 .login-title {
     margin-top: 20px;
     margin-bottom: 20px;
     font-size: 24px;
     font-weight: bold;
     color: #333;
 }

 .login-input {
     margin-top: 20px;
     border-radius: 3px;
     padding: 10px;
     font-size: 16px;
     background-color: rgba(255, 255, 255, 0.5);
     outline: medium;
     border: 1px solid #eee;
     width: 70%;
 }

 .login-button {
     margin-top: 60px;
     border: none;
     border-radius: 3px;
     padding-top: 5px;
     padding-bottom: 5px;
     font-size: 70px;
     color: #3F90F7;
 }

 /* 禁止 Chrome 自动填充修改 input 样式 */
 input:-webkit-autofill,
 input:-webkit-autofill:hover,
 input:-webkit-autofill:focus,
 input:-webkit-autofill:active {
     -webkit-transition-delay: 99999s;
     -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
 }

 .verification-button {
     margin-top: 20px;
     width: 70%;
 }
</style>
